/**
 * @file Catering.js
 * @author Stanley Chen
 * @description Catering component that showcases Kiku's catering services with
 * an animated video and text section, linking to the catering website
 */

import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import OutboundLink from '../OutboundLink';
import './Catering.css';

const Catering = () => {
  const sectionRef = useRef(null);
  const videoRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, amount: 0.3 });
  
  return (
    <section className="catering-section" id="catering" ref={sectionRef}>
      <div className="catering-container">
        <div className="catering-content">
          <div className="catering-image-wrapper">
            <div className="catering-border"></div>
            <motion.div 
              className="catering-video"
              initial={{ opacity: 0, y: 100 }}
              animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }}
              transition={{ duration: 0.8 }}
            >
              <video
                ref={videoRef}
                autoPlay
                loop
                muted
                playsInline
                className="catering-video-element"
              >
                <source src="/videos/my-hibachi-party.m4v" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </motion.div>
          </div>
          
          <motion.div 
            className="catering-text"
            initial={{ opacity: 0, y: -100 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: -100 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h2>CATERING</h2>
            <p>
              We bring our hibachi grill, skilled and entertaining chef, quality food, and sake (Japanese rice wine) to your own backyard. We offer flexible 
              options including sushi platters, hibachi stations, and traditional 
              Japanese favorites, all prepared with the same care and quality as in our restaurant.
            </p>
            <OutboundLink 
              href="https://www.myhibachiparty.com/"
              label="Catering Website (Main Section)"
            >
              <motion.button 
                className="primary-btn"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                CATER NOW
              </motion.button>
            </OutboundLink>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Catering;